// extracted by mini-css-extract-plugin
module.exports = {"moreInfoWrap":"culture-more-info_moreInfoWrap__8hY0X","title":"culture-more-info_title__Hc1m_","title--blue":"culture-more-info_title--blue__XwbkN"};